import { fetchTelegramIdentityRequest } from '../fetch-telegram-identity-request';
import type { IFinalizeTelegramRequest } from './finalize-telegram-request';
import type { IFinalizeTelegramResponse } from './finalize-telegram-response';
import { finalizeTelegramResponseSchema } from './finalize-telegram-response';

export async function finalizeTelegramApi(
  data: IFinalizeTelegramRequest,
): Promise<IFinalizeTelegramResponse> {
  const response = await fetchTelegramIdentityRequest('/telegram/oidc/finalize', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw new Error(`Telegram finalize failed: ${response.status}`);
  }
  const json = await response.json();
  return finalizeTelegramResponseSchema.parse(json);
}
